<div class="flex flex-col text-center justify-center h-full">
    <h5 class="pl-12 pr-12" *ngIf="intentSource === 'SALES_INTEL'">
        PredictiveIntent is not currently part of your SalesIntel plan. Please contact
        your SalesIntel representative to add PredictiveIntent and begin setting up automated
        alerts.
    </h5>
    <h5 class="pl-12 pr-12" *ngIf="intentSource === 'BOMBORA'">
        Bombora Intent is not currently part of your SalesIntel plan. Please contact
        your SalesIntel representative to add Bombora Intent and begin setting up automated
        alerts.
    </h5>
    <h5 class="pl-12 pr-12" *ngIf="intentSource === 'BOTH'">
        Neither PredictiveIntent nor Bombora Intent is currently part of your SalesIntel plan. Please contact
        your SalesIntel representative to add Intent capabilities and begin setting up automated
        alerts.
    </h5>
</div>
